<router-outlet>
  <app-spinner><app-title></app-title></app-spinner>
</router-outlet>



// WEBPACK FOOTER //
// ./src/app/layout/auth/auth.component.html